import { API, API_POST } from "../../config";

export const DeleteReport = (id, status) => {
  const f = new FormData();
  f.append("id", id);
  f.append("status", status);

  return API_POST(API.deletereport, f);
};
